<template>
<span id="mileage">
    {{user_mileage.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
</span>
</template>

<script>
// 사용자 정의 모듈.
import * as config from '../../javascript/config';
export default {
    data: function () {
        return {
            user_id: '',
            user_mileage: 0,
            user_mileage_id: 0
        }
    },
    methods: {

    },
    mounted() {
        var user_data = this.$store.getters['getUser'];
        if (user_data.user_id != 0) {
            const my_info_data = {
                'user_id': user_data.user_id
            };
            const type = config.REQ_MILEAGE_GET;

            this.$store.dispatch(type.action_name, {
                type: type,
                data: my_info_data
            }).then(response => {
                if (response.data.length > 0) {
                    this.user_mileage = response.data[0].total_amount;
                    this.user_mileage_id = response.data[0].mileage_id;
                }
                this.$emit("milage", this.user_mileage, this.user_mileage_id);
            }).catch(function (error) {
                console.log('error=============>', error);
            });
        }

    },
    watch: {

    }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/components/mileage.vue